import VehicleSelect from "./index.vue";

VehicleSelect.install = Vue => Vue.component(VehicleSelect.componentName, VehicleSelect);

export default VehicleSelect;
